import { EmeraldErrorModal } from 'src/common/api/emerald-error';
import { EmeraldDialogTypes } from 'src/common/enumerations/emerald-dialog-types';

export const transactionNotFoundErrorModal = new EmeraldErrorModal({
  message: 'TransactionNotFoundException',
  subMessage: 'TransactionNotAvailiable',
  type: EmeraldDialogTypes.Warning,
});
